import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface StatCardProps {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  iconBg?: string;
  iconColor?: string;
  sub?: ReactNode;
  onClick?: () => void;
  hoverBorderClassName?: string;
  className?: string;
}

export function StatCard({
  label, value, icon, iconBg = 'bg-gray-50', iconColor = 'text-gray-600',
  sub, onClick, hoverBorderClassName = 'hover:border-teal-300', className,
}: StatCardProps) {
  const content = (
    <>
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-medium text-gray-500">{label}</p>
        {icon && (
          <div className={cn('w-9 h-9 rounded-lg flex items-center justify-center shrink-0', iconBg)}>
            <span className={iconColor}>{icon}</span>
          </div>
        )}
      </div>
      <p className="text-3xl font-bold text-gray-900">{value}</p>
      {sub && <p className="text-xs text-gray-400 mt-1">{sub}</p>}
    </>
  );

  const baseClass = cn('bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-left w-full', className);

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(baseClass, hoverBorderClassName, 'hover:shadow-md transition cursor-pointer')}
      >
        {content}
      </button>
    );
  }
  return <div className={baseClass}>{content}</div>;
}
